<template>

  <div>
    <!-- Query conditioner -->
    <div class="row">
      <div class="col-xl-9">
        <el-card shadow="never" class="h-100">
          <div class="row">
            <!-- Date range picker and several settings -->
            <div class="col-xl-7">
              <date-range-picker :from="queryParams.from" :to="queryParams.to" @on-change="applyDateRange"
                :shortcuts="dateRangeShortcuts" :earliest="dateRangePickerEarliest"></date-range-picker>
              <br>
              <div class="row">
                <div class="col-12 col-xl-6 px-4 py-2">
                  <el-switch class="d-inline" v-model="queryParams.timeBasedOn" @change="applyBasedTimeRange"
                    active-color="#13CE66" inactive-color="#439CFE"
                    :active-text="i18nDynamicLabel.LABEL_TAKE_MEAL_TIME" :inactive-text="$t('Orders.Order_Time')"
                    active-value="take_meal_time" inactive-value="created_at">
                  </el-switch>
                </div>
                <div class="col-12 col-xl-6 px-2 py-2">
                  <el-checkbox-group class="d-inline ml-2" v-model="queryParams.mealTypes" :min="1" @change="fetchOrders">
                    <el-checkbox label="eat_in">{{ i18nDynamicLabel.LABEL_EAT_IN }}</el-checkbox>
                    <el-checkbox label="to_go">{{ i18nDynamicLabel.LABEL_TO_GO }}</el-checkbox>
                    <el-checkbox label="delivery">{{ i18nDynamicLabel.LABEL_DELIVERY }}</el-checkbox>
                    <el-checkbox label="takeaway">{{ i18nDynamicLabel.LABEL_TAKEAWAY }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="col-12 px-3 py-2">
                  <el-checkbox-group class="d-inline ml-2" v-model="queryParams.platforms" :min="1" @change="fetchOrders">
                    <el-checkbox label="quickclick">{{ labels.LABEL_PLATFORM_QC }}</el-checkbox>
                    <el-checkbox label="gofoodie">{{ labels.LABEL_PLATFORM_GF }}</el-checkbox>
                    <el-checkbox label="ubereats">{{ labels.LABEL_PLATFORM_UE }}</el-checkbox>
                    <el-checkbox label="foodpanda">{{ labels.LABEL_PLATFORM_FP }}</el-checkbox>
                    <el-checkbox label="counter">{{ labels.LABEL_PLATFORM_CO }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <!-- Account selector -->
            <div class="col-xl-5 pl-5">
              <!-- <account-selector :user="user" @apply-account="applyAccount"></account-selector> -->
              <ShopFinder @shop-selected="onShopSelected" @si-selected="onSiSelected"></ShopFinder>              
              <div class="d-flex">
                <!-- <el-button round type="default" icon="el-icon-refresh" @click="fetchOrders">重新整理</el-button> -->
                <el-button round type="warning" icon="el-icon-download" @click="doExport">{{$t('Orders.Export_Details')}}</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="col-xl-3">
        <el-card shadow="never" class="h-100">
          <div slot="header" class="clearfix"> <span>{{ $t('Orders.Advanced_Search') }}</span> </div>
          <el-form rel="form-adv-search" :inline="true" @submit.native.prevent
            label-width="auto">
            <el-form-item>
              <el-input :placeholder="`(${$t('Orders.Order_Number')})`" v-model="queryParams.advSearch.id"
                maxlength="40" clearable>
                <el-button slot="append" @click="applyAdvancedSearchId">{{ $t('Orders.Search') }}</el-button>
              </el-input>
            </el-form-item>
            <br><br>
            <el-form-item>
              <el-input :placeholder="`(${$t('Orders.Message.Phone_within_3_months')})`" v-model="queryParams.advSearch.phone"
                maxlength="12" clearable>
                <el-button slot="append" @click="applyAdvancedSearchPhone">{{ $t('Orders.Search') }}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
    <br>

    <!-- List of orders -->
    <el-row>
      <el-col :span="24">

        <data-table ref="table"
          :data="orders" :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChange" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]" :on-rows-per-page-change="onRowsPerPageChange">

          <div slot="platform" slot-scope="{row}">
            <template>
              <div v-if="row.platform === 'gofoodie'">
                <img :src="gofoodieLogoSrc">
              </div>
              <div v-else-if="row.platform === 'ubereats'">
                <img :src="ubereatsLogoSrc" width="32px">
              </div>
              <div v-else-if="row.platform === 'foodpanda'">
                <img :src="foodpandaLogoSrc" width="32px">
              </div>
              <div v-else-if="row.platform === 'counter'">
                <img :src="counterLogoSrc" width="32px">
              </div>
            </template>
          </div>
          <!-- <div slot="Time" slot-scope="{row}">
            {{row.created_at}}<br><small class="text-muted" v-if="row.take_meal_time">取餐 {{row.take_meal_time}}</small>
          </div> -->
          <div slot="Time1" slot-scope="{row}">
            {{row.created_at | toDateTimeString}}
          </div>
          <div slot="Time2" slot-scope="{row}">
            {{row.take_meal_time | toDateTimeString}}
          </div>

          <!-- <div slot="DeliveryFee" slot-scope="{row}">
            <b>${{Number(row.delivery_fee).toLocaleString()}}</b>
          </div> -->
          <div slot="Amount" slot-scope="{row}">
            <b>${{Number(row.amount).toLocaleString()}}</b>
            <span v-if="row.meal_types == 'delivery'"><br>{{ $t('Orders.Shipping_Fee', {delivery_fee: Number(row.delivery_fee).toLocaleString()}) }}</span>
          </div>

          <div slot="PaymentTypes" slot-scope="{row}">
            <span v-if="['cash','paid_on_site'].indexOf(row.payment_types) >= 0">{{ $t('Orders.Onsite') }}</span>
            <span v-else-if="row.payment_types === 'paid_at_counter'">{{ $t('Orders.AtCounter') }}</span>
            <span v-else-if="row.payment_types === 'pending'">{{ $t('Orders.Pending') }}</span>
            <span v-else-if="row.payment_types === 'multiple'">{{ $t('Orders.Online') }}</span>
            <span v-else-if="row.payment_types === 'qrpay_easywallet'">{{ $t('Orders.Easy_Wallet') }}</span>
            <span v-else-if="row.payment_types === 'qrpay_jko'">
              <el-image :src="require('../../../assets/img/gaa-other/JKO-gray.png')" style="height: 25px;"></el-image>
            </span>
            <span v-else-if="row.payment_types === 'qrpay_icashpay'">icash Pay</span>
            <span v-else-if="['qrpay_pxpayplus', 'pxpayplus'].indexOf(row.payment_types) >= 0">全支付</span>
            <span v-else-if="['qrpay_pluspay', 'pluspay'].indexOf(row.payment_types) >= 0">全盈支付</span>
            <span v-else-if="['qrpay_taiwanpay', 'taiwanpay'].indexOf(row.payment_types) >= 0">台灣Pay</span>
            <span v-else-if="['twqr', 'yuanta', 'qrpay_twqr', 'qrpay_yuanta'].indexOf(row.payment_types) >= 0">TWQR</span>
            <span v-else-if="['aftee', 'qrpay_aftee'].indexOf(row.payment_types) >= 0">Aftee</span>
            <span v-else-if="row.payment_types === 'qrpay_gcash_ewallet'">GCASH</span>
            <span v-else-if="row.payment_types === 'qrpay_gcash_scan2pay'">GCASH</span>
            <span v-else-if="row.payment_types === 'qrpay_maya_web'">GCASH</span>
            <span v-else-if="row.payment_types === 'qrpay_maya_scan2pay'">MAYA</span>
  
            <font-awesome-icon v-else size="2x" :icon="getPayTypeIcon(row)" />
          </div>

          <div slot="MealTypes" slot-scope="{row}">
            <span v-if="row.meal_types === 'eat_in'">{{ i18nDynamicLabel.LABEL_EAT_IN }}</span>
            <span v-if="row.meal_types === 'to_go'">{{ i18nDynamicLabel.LABEL_TO_GO }}</span>
            <span v-if="row.meal_types === 'delivery'">{{ i18nDynamicLabel.LABEL_DELIVERY }}</span>
            <span v-if="row.meal_types === 'takeaway'">{{ i18nDynamicLabel.LABEL_TAKEAWAY }}</span>
          </div>

          <div slot="Status" slot-scope="{row}">
            <i class="el-icon-remove" v-if="row.is_cancelled == 1"></i>
            <span v-else-if="row.is_lala_cancelled">{{ $t('Orders.Logistics_Cancellation') }}</span>
            <i class="el-icon-success" v-else-if="row.is_confirmed == 1"></i>
            <span v-else>{{ $t('Orders.Unpaid') }}</span>
          </div>

          <div slot="Actions" slot-scope="{row}">
            <el-button type="primary" icon="el-icon-info" circle size="small" @click="showOrderDetail(row)"></el-button>
          </div>

        </data-table>
        
      </el-col>
    </el-row>

    

    <!-- Dialog of order detail -->
    <OrderDetailDialog :show.sync="dialog.detail.show" :order-id="dialog.detail.orderId">
    </OrderDetailDialog>

    
  </div>
</template>

<script>
import {
  Button
} from 'element-ui';
import DateRangePicker from 'src/components/DateRangePicker';
import {Modal} from 'src/components';
import DataTable from 'src/components/DataTable';
// import AccountSelector from './AccountSelector.vue';
import ShopFinder from 'src/components/ShopFinder.vue';
import OrderDetailDialog from './DialogOrderDetail.vue'; 

import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';
import { i18n } from "../../../vue-i18n-plugin";

export default {
  components: {
    [Button.name]: Button,
    DateRangePicker,
    Modal,
    DataTable,
    // AccountSelector,
    ShopFinder,
    OrderDetailDialog
  },
  mixins: [ UserInfoMixin ],

  mounted() {

    // Obtain list of orders.
    this.fetchOrders();
  },

  methods: {
    fetchOrders() {
      console.warn(`[ORDERS] Querying orders by...`, this.queryParams);
      this.isLoading = true;

      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      if (this.userType != 'gaa' && toMoment.diff(fromMoment, 'days') > 31) {
        alert(this.$t("Orders.Message.Up_to_one_month"));
        return;
      }

      // Compose query URL.
      let url = `${process.env.VUE_APP_APIHOST}/${this.userType}/orders?dateType=ts&joinShopNames=true&includeNotes=true&includeStatus=true&includeCheckoutType=true`
          // + `&startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`
          + (this.queryParams.sort? `&sort=${this.queryParams.sort}`: '');

      // Append query conditions
      if (this.queryParams.advSearch.keyword.length) { //Adv search
        if (this.queryParams.advSearch.searchBy === 'order_id')
          url += `&search=${this.queryParams.advSearch.keyword}:order_id&limit=-1`;
        else if (this.queryParams.advSearch.searchBy === 'phone')
          url += (
            `&from=${moment().add(-3, 'months').unix()}&to=${moment().unix()}`
            + `&startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`
            + `&search=${this.queryParams.advSearch.keyword}:phone`
            + (this.queryParams.accountId > 0? `&shopId=${this.queryParams.accountId}`: '')
          );
      }
      else { //Common search
        url += (
          // Time range
          `&from=${fromMoment.unix()}&to=${toMoment.unix()}`
          + `&startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`
          + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
          // Meal type filter
          + ((this.queryParams.mealTypes.length && this.queryParams.mealTypes.length < 3)? `&mealTypes=${this.queryParams.mealTypes.join(',')}`: '')
          // Platform filter
          + ((this.queryParams.platforms.length && this.queryParams.platforms.length < 5)? `&platforms=${this.queryParams.platforms.join(',')}`: '')
          // Account scope
          + (this.queryParams.siId > 0? `&siId=${this.queryParams.siId}`: '')
          + (this.queryParams.eaaId > 0? `&eaaId=${this.queryParams.eaaId}`: '')
          + (this.queryParams.accountId > 0? `&shopId=${this.queryParams.accountId}`: '')
        );
      }

      // Make actual request.
      axios.get(url)
      .then(response => {
        console.log(`[ORDERS] Order list fetched`, response.data);
        this.total = response.data.total;
        this.orders = response.data.orders;
        return;
      })
      .catch(err => {
        console.error(`[ORDERS] Cannot fetch order list`, err);
        let errMessage;
        if (err.data && err.data.code) {
          if (err.data.code == 'PROTOCOL_SEQUENCE_TIMEOUT')
            errMessage = this.$t("Orders.Message.Narrow_your_query");
          else
            errMessage = err.data.message
        }
        this.$notify.error({
          title: this.$t("Orders.Query_Error"),
          message: errMessage
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    doExport() {
      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      if (toMoment.diff(fromMoment, 'days') > 31) {
        alert(this.$t("Orders.Message.Up_to_one_month"));
        return;
      }
      let fromTs = fromMoment.unix(), toTs = toMoment.unix();
      if (isNaN(fromTs) || isNaN(toTs)) {
        alert(this.$t("Orders.Message.Wrong_date"));
        return;
      }

      const defaultPlatformName = i18n.locale == 'en'?
        (process.env.VUE_APP_BRANDNAME_EN || process.env.VUE_APP_BRANDNAME) :
        process.env.VUE_APP_BRANDNAME;
      window.open(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/orders/export`
        + `?lang=${i18n.locale}&dateType=datetime&joinShopNames=true&includeNotes=true&from=${fromTs}&to=${toTs}`
        + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
        + (this.queryParams.sort? `&sort=${this.queryParams.sort}`: '')
        + (this.queryParams.mealTypes.length? `&mealTypes=${this.queryParams.mealTypes.join(',')}`: '')
        + ((this.queryParams.platforms.length && this.queryParams.platforms.length < 5)? `&platforms=${this.queryParams.platforms.join(',')}`: '')
        + (this.queryParams.siId > 0? `&siId=${this.queryParams.siId}`: '')
        + (this.queryParams.eaaId > 0? `&eaaId=${this.queryParams.eaaId}`: '')
        + (this.queryParams.accountId > 0? `&shopId=${this.queryParams.accountId}`: '')
        + `&limit=-1&defaultPlatformName=${encodeURIComponent(defaultPlatformName)}`
      );
    },

    applyDateRange(dates) {
      this.queryParams.isDefaultDateRange = false;
      this.queryParams.from = dates[0];
      this.queryParams.to = dates[1];

      //FIXME: Reset limit-offset.
      this.queryParams.startIndex = 0;
      //FIXME: Reset adv-search input.
      this.queryParams.advSearch.id = '';
      this.queryParams.advSearch.phone = '';
      this.queryParams.advSearch.keyword = '';

      this.fetchOrders();
    },
    applyBasedTimeRange() {
      this.queryParams.sort = `${this.queryParams.timeBasedOn}:desc`;
      //FIXME: Reset adv-search input.
      this.queryParams.advSearch.keyword = '';
      
      this.fetchOrders();
    },
    applyAdvancedSearchId() {
      //FIXME: Reset limit-offset.
      this.queryParams.startIndex = 0;
      this.queryParams.advSearch.keyword = this.queryParams.advSearch.id;
      this.queryParams.advSearch.searchBy = 'order_id';
      this.queryParams.advSearch.phone = '';
      this.fetchOrders();
    },
    applyAdvancedSearchPhone() {
      this.queryParams.startIndex = 0;
      this.queryParams.advSearch.keyword = this.queryParams.advSearch.phone;
      this.queryParams.advSearch.searchBy = 'phone';
      this.queryParams.advSearch.id = '';
      this.fetchOrders();
    },
    onSiSelected(siId) {
      this.queryParams.siId = siId || 0;
      this.queryParams.accountId = 0;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      this.queryParams.advSearch.keyword = '';
      this.queryParams.advSearch.id = '';
      this.queryParams.advSearch.phone = '';
      this.fetchOrders();
    },
    onShopSelected(shopId, shopName) {
      this.queryParams.accountId = shopId || 0;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      this.queryParams.advSearch.keyword = '';
      this.queryParams.advSearch.id = '';
      this.queryParams.advSearch.phone = '';
      this.fetchOrders();
    },

    onSortChange({prop, key, order}) {
      // console.warn('[ORDERS] DataTable: onSortChange', prop, key, order);
      let ordering = order === 'ascending'? 'asc': 'desc';
      this.queryParams.sort = `${prop}:${ordering}`;
      this.fetchOrders();
    },
    onPageRequest(page) {
      // console.warn(`[ORDERS] DataTable: Trying to fetch page ${page}...`);
      this.queryParams.startIndex = (page - 1) * this.queryParams.limit;
      this.fetchOrders();
    },
    onRowsPerPageChange(rpp) {
      this.queryParams.limit = rpp;
      this.queryParams.startIndex = 0;
      this.fetchOrders();
    },

    getPayTypeIcon(row) {
      switch (row.payment_types) {
        case 'qrpay_apple': return ['fab', 'apple-pay'];
        case 'qrpay_google': return ['fab', 'google'];
        case 'qrpay_line': return ['fab', 'line'];
        case 'qrpay_credit': return ['fas', 'credit-card'];
        default: return []
      }
    },

    showOrderDetail(order) {
      this.dialog.detail.orderId = order.order_id;
      this.dialog.detail.show = true;
    }
  },

  data() {
    return {
      orders: [],
      total: 100,//FIXME: To be updated.
      isLoading: false,

      queryParams: {
        from: moment().startOf('day').toDate(),
        to: new Date(),
        timeBasedOn: 'created_at',

        startIndex: 0,
        limit: 10,
        sort: 'created_at:desc',

        mealTypes: ['eat_in', 'to_go', 'delivery', 'takeaway'],
        platforms: ['quickclick', 'gofoodie', 'ubereats', 'foodpanda', 'counter'],

        advSearch: {
          keyword: '', searchBy: '',
          id: '', phone: ''
        },

        siId: 0,//WARNING: Will determine this value when mounted.
        eaaId: 0, //WARNING: Will determine this value when mounted.
        accountId: undefined
      },

      labels: {
        // LABEL_PLATFORM_QC: '快一點',
        LABEL_PLATFORM_QC: process.env.VUE_APP_BRANDNAME,
        LABEL_PLATFORM_UE: 'Uber Eats',
        LABEL_PLATFORM_FP: 'Foodpanda',
        LABEL_PLATFORM_GF: 'GoFoodie',
        LABEL_PLATFORM_CO: this.$t("Orders.Counter_Order")
      },

      dialog: {
        // show: false,
        // shop_id: undefined,
        // shop_name: '',
        // order: {id: -1},
        // cart: [],
        // user: undefined,
        // account_addon: {display: '', amount: 0},
        // status_logs: [],
        // lalamove_logs: [],
        // isLoading: false,

        detail: {
          show: false,
          orderId: null
        }
      },
      // defaultProductImage: `${process.env.BASE_URL}img/dish.png`,

      siAccountOptions: [
        {label: '（所有）', value: -1}
      ],
      eaaAccountOptions: [
        {label: '（所有）', value: -1}
      ],
      shopOptions: [
        {label: '（所有）', value: -1}
      ]

    };
  },

  computed: {
    cols() {
      return [
        {prop: 'id', key: 'id', label: this.$t("Orders.Id"), width: 96, align: 'center', sortable: true},
        {prop: 'shop_name', key: 'shop_name', label: this.$t("Orders.Store"), sortable: true},
        {prop: 'Time1', key: 'created_at', label: this.$t("Orders.Order_Time"), sortable: true},
        {prop: 'Time2', key: 'take_meal_time', label: this.$route.meta.retail? this.$t("Orders.Pickup_Time"): this.$t("Orders.Meal_Pickup_Time"), sortable: true},
        {prop: 'order_number', key: 'order_number', label: '#', width: 80, sortable: true},
        {prop: 'platform', key: 'platform', label: `${this.$t("Orders.Platform")}`, width: 96, align: 'center'},
        {prop: 'Amount', key: 'amount', label: this.$t("Orders.Amount"), width: 108, align: 'right', sortable: true},
        {prop: 'PaymentTypes', key: 'payment_types', label: this.$t("Orders.Payment_Method"), width: 80, align: 'center'},
        {prop: 'MealTypes', key: 'meal_types', label: this.$route.meta.retail? this.$t("Orders.Pickup_Method"): this.$t("Orders.Meal_Pickup_Method"), width: 80, align: 'center'},
        {prop: 'Status', key: 'is_confirmed', label: this.$t("Orders.Order_Status"), width: 80, align: 'center'},
        {prop: 'Actions', key: '', label: '', width: 72}
    ]} ,
    i18nDynamicLabel() {
      let label = {};

      // Adjust wordings accordingly.
      if (this.$route.meta.retail === true) {
        label = {
          LABEL_EAT_IN: this.$t("Orders.Self_Pickup"),
          LABEL_TO_GO: this.$t("Orders.Customization"),
          LABEL_DELIVERY: this.$t("Orders.Home_Delivery"),
          LABEL_TAKE_MEAL_TIME: this.$t("Orders.Pickup_Time"),
          LABEL_TAKEAWAY: this.$t("Orders.Customization"),
        };
      } else {
        label = {
          LABEL_EAT_IN: this.$t("Orders.Dinein"),
          LABEL_TO_GO: this.$t("Orders.Self_Pickup"),
          LABEL_DELIVERY: this.$t("Orders.Delivery"),
          LABEL_TAKE_MEAL_TIME: this.$t("Orders.Meal_Pickup_Time"),
          LABEL_TAKEAWAY: this.$t("Orders.Takeaway"),
        };
      }

      return label;
    },
    dateRangeShortcuts() {
      return [
        {
          label: this.$t("Orders.Today"),
          from: moment()
            .startOf("day")
            .toDate()
        },
        {
          label: this.$t("Orders.Yesterday"),
          from: moment()
            .add(-1, "days")
            .startOf("day")
            .toDate(),
          to: moment()
            .add(-1, "days")
            .endOf("day")
            .toDate()
        },
        {
          label: this.$t("Orders.This_Week"),
          from: moment()
            .startOf("isoWeek")
            .toDate()
        },
        {
          label: this.$t("Orders.Last_Week"),
          from: moment()
            .add(-1, "week")
            .startOf("isoWeek")
            .toDate(),
          to: moment()
            .add(-1, "week")
            .endOf("isoWeek")
            .toDate()
        },
        {
          label: this.$t("Orders.This_Month"),
          from: moment()
            .startOf("month")
            .toDate()
        },
        {
          label: this.$t("Orders.Last_Month"),
          from: moment()
            .add(-1, "month")
            .startOf("month")
            .toDate(),
          to: moment()
            .add(-1, "month")
            .endOf("month")
            .toDate()
        }
      ]
    },
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if ([ 'gaa', 'si' ].indexOf(this.userType) >= 0)
        return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },

    // Computed data for order detail "el-table"s.
    cartData() {
      return this.dialog.cart;
    },
    
    deliveryData() {
      let data = [];
      data.push({key: '外送地址', val: this.dialog.order.delivery_address});
      data.push({
        key: '物流取餐時間',
        val: this.dialog.order.lala_take_meal_time? moment.unix(this.dialog.order.lala_take_meal_time).format('YYYY/M/D h:mmA'): '（非物流平台，無指定時間）'
      });
      data.push({key: '運送需時（分鐘）', val: this.dialog.order.delivery_time});
      data.push({key: '備註', val: this.dialog.order.lala_notes});
      data.push({
        key: '物流取消',
        val: {0: '否', 1: '是'}[this.dialog.order.is_lala_cancelled]
          + (this.dialog.order.is_lala_cancelled? ` (${moment.unix(this.dialog.order.updated_at).format('YYYY/M/D h:mmA')})`: '')
      });
      return data;
    },

    gofoodieLogoSrc() {
      return `${process.env.BASE_URL}img/icons/gofoodie-simple-logo.png`;
    },
    foodpandaLogoSrc() {
      return `${process.env.BASE_URL}img/icons/foodpanda.svg`;
    },
    ubereatsLogoSrc() {
      return `${process.env.BASE_URL}img/icons/ubereats.svg`;
    },
    counterLogoSrc() {
      return `${process.env.BASE_URL}img/icons/counter.svg`
    }
  },

  filters: {
    toDateTimeString(ts) {
      return moment.unix(ts).format('YYYY/M/D h:mmA');
    },
    toStatusLiteral(status) {
      return {
        'new': '新進單',
        'accepted': '已接單',
        'rejected': '已取消（拒接）',
        'done': '已完成',
        'cancelled': '已取消',
        'lala_assigning_driver': '物流媒合中',
        'lala_on_going': '物流前往取貨中',
        'lala_picked_up': '物流已取貨',
        'lala_completed': '物流已送達',
        'lala_rejected': '物流已取消（拒接）',
        'lala_cancelled': '物流已取消',
        'lala_expired': '物流已逾期',
        'customer_service': '已轉交客服'
      }[status];
    }
    
  }
};
</script>

<style scoped>
i.el-icon-success {color: green; font-size: 20px;}
i.el-icon-remove {color: red; font-size: 20px;}

.row > .col,
.row > [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}
</style>